import React, { useCallback, useMemo } from "react";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Alert from "@material-ui/lab/Alert";
import Typography from "@material-ui/core/Typography";

import Dialog from "./shared/Dialog";
import useModal from "../hooks/useModal";
import { useAppContext } from "../api/AppContext";

const CopyJourneyModal = ({ journey, onConfirm, onClose }) => {
  const { isLoading, handleConfirm } = useModal({
    onClose,
    onConfirm: useCallback(() => onConfirm(journey), [journey, onConfirm]),
  });

  const { materials } = useAppContext();

  const unsupportedMaterials = useMemo(() => {
    return materials.filter(
      (material) =>
        material.journeyId === journey.id &&
        (material.type === "SEMANTIC" || material.type === "SURVEY")
    );
  }, [materials, journey.id]);

  return (
    <Dialog fullWidth open maxWidth="xs">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          {`Copy "${journey.internalName || journey.name}" Journey?`}
          <div>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          All materials and interactions will be copied to the new Journey
        </DialogContentText>
        {unsupportedMaterials.length > 0 && (
          <Alert severity="warning" style={{ marginTop: 16 }}>
            <Typography variant="body2">
              Note: This journey contains {unsupportedMaterials.length}{" "}
              material(s) of unsupported type(s) which will not be copied to the{" "}
              new journey.
            </Typography>
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          autoFocus
          color="primary"
          disabled={isLoading}
          endIcon={isLoading && <CircularProgress size={25} />}
          variant="contained"
          onClick={handleConfirm}
        >
          Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopyJourneyModal;
